import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {

    constructor() {
    }

    static show() {
        document.getElementById('loading').style.display = 'flex';
    }

    static hide() {
        document.getElementById('loading').style.display = 'none';
    }

}
